import {Component, inject, input, OnDestroy, OnInit, signal} from "@angular/core";
import {MatSnackBarAction, MatSnackBarLabel, MatSnackBarRef} from "@angular/material/snack-bar";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {MatProgressBar} from "@angular/material/progress-bar";

@Component({
	selector: "sim-snackbar",
	templateUrl: "./snackbar.component.html",
	styleUrl: "./snackbar.component.scss",
	imports: [MatIcon, MatSnackBarLabel, TranslateModule, MatIconButton, MatSnackBarAction, MatProgressBar],
})
export class SnackbarComponent implements OnInit, OnDestroy {
	// I/O
	public readonly icon = input.required<string>();
	public readonly duration = input.required<number>();

	// Properties
	protected timerPercentage = signal<number>(0);
	#timerInterval: number = 0;

	// Injections
	protected readonly snackbarRef = inject(MatSnackBarRef<SnackbarComponent>);

	public ngOnInit(): void {
		this.doCountdown();
	}

	public ngOnDestroy(): void {
		clearInterval(this.#timerInterval);
	}

	private doCountdown() {
		// Prep calc data
		let percentage = 0;
		const interval = 100;
		const calcDecrement = 100 / (this.duration() / interval);

		// Start the countdown
		this.#timerInterval = setInterval(() => {
			percentage += calcDecrement;

			// Update the signals
			this.timerPercentage.set(percentage);

			// End countdown
			if (percentage >= 100) {
				clearInterval(this.#timerInterval);
			}
		}, interval);
	}
}
